import { useResetPwdMutate } from "./sercice";
import useAlertStore from "store/alert";
import { useLocation } from "react-router-dom";

type IRestPwdProps = {
  form: HTMLFormElement;
  lgnPwd: string;
};

export const useResetPwd = () => {
  const onSetAlert = useAlertStore((state) => state.onSetAlert);
  const { state } = useLocation();
  const { mutate } = useResetPwdMutate();
  const onSubmit = ({ lgnPwd, form }: IRestPwdProps) => {
    // ❌ validation 실패
    if (!form.checkValidity()) {
      form.reportValidity(); // required 문구 표시
      return;
    }

    onSetAlert({
      isOpen: true,
      inner: "비밀번호를 설정하시겠습니까?",
      cnclBtn: true,
      onSetConfirm: () => {
        mutate({
          newLgnPwd: lgnPwd,
          certEncParam: state?.certEncParam ?? undefined,
        });
      },
    });
  };

  return {
    onSubmit,
  };
};
